import Action from '../#Action';

export default class CloseAllCollapses extends Action {
  /** The action namespace */
  static namespace = 'Core/Collapse';

  /** The base action type */
  static type = 'Core/Collapse/CloseAllCollapses' as const;

  constructor() {
    super();
    this.type = (this.constructor as typeof CloseAllCollapses).type;
  }
}
